import {
  PhotoMatchDecisionResponse,
  PhotoMatchDetailResponse,
} from '../../../application/ports/outbound/IPendingPhotoVerificationRepository';
import { PhotoMatchDecisionResponseDto } from '../dto/res/PhotoMatchDecisionResponseDto';
import { PhotoMatchDetailResponseDto } from '../dto/res/PhotoMatchDetailResponseDto';

export class PhotoMatchMapper {
  static toDetailResponse(dto: PhotoMatchDetailResponseDto): PhotoMatchDetailResponse {
    return {
      caseId: dto.caseId,
      caseNumber: dto.caseNumber,
      caseStatus: dto.caseStatus,
      caseStatusDisplay: dto.caseStatusDisplay,
      documentType: dto.documentType,
      employeeDocFrontBase64: dto.employeeDocFrontBase64,
      employeeDocBackBase64: dto.employeeDocBackBase64,
      dhsPhotoBase64: dto.dhsPhotoBase64,
      firstName: dto.firstName,
      lastName: dto.lastName,
    };
  }

  static toDecisionResponse(dto: PhotoMatchDecisionResponseDto): PhotoMatchDecisionResponse {
    return {
      success: dto.success,
      message: dto.message,
      queued: dto.queued,
      caseNumber: dto.caseNumber,
      caseStatus: dto.caseStatus,
      caseStatusDisplay: dto.caseStatusDisplay,
      nextAction: dto.nextAction,
    };
  }
}
